import { makeHttpRequest } from "@/shared";

export const deleteRepairs = async (ids) => {
    const response = (
        await makeHttpRequest({
            url: `/repair/delete-multiple`,
            method: "DELETE",
            params: {
                repairs: ids,
            },
        })
    ).data;

    return response;
};
